<template>
  <div>
    <ul class="f-clearfix">
      <li
        class="item-title border-bottom"
        v-for="(item, index) of list"
        :key="index"
      >
        <a
          href="javascript:void(0);"
          :class="id == item.id ? 'active' : ''"
          @click="clickCourse(item, index)"
          >{{ item.title }}</a
        >
      </li>
    </ul>
    <div v-if="childrenList != ''" class="item-children">
      <categoryList
        ref="childList"
        :list="childrenList || ''"
        :tabs="tabs"
        :urlFlag="urlFlag"
        :flagNum="num"
        :allList="allList"
        @getNewList="getNewList"
        @getHotList="getHotList"
      ></categoryList>
    </div>
  </div>
</template>
<script>
import categoryList from "./categoryList.vue";
import merge from "webpack-merge";
export default {
  name: "categoryList",
  components: {
    categoryList,
  },
  props: ["list", "tabs", "urlFlag", "flagNum", "allList"],

  computed: {},
  data() {
    return {
      childrenList: [],
      id: "",
      clist: [],
      num: 0,
      flagCategoryIds: [],
      flagTagCourseIds: [],
      flagSchoolIds: [],
      flagTagProjectIds: [],
      flagStatusIds: [],
    };
  },
  mounted() {
    this.waint();
  },
  methods: {
    waint() {
      setTimeout(async () => {
        let pathId = this.$route.query;
        console.log(this.list);
        if (this.urlFlag == "category") {
          this.id = pathId.categoryId;
          await this.getTrees(this.id, this.list);
          await this.show(this.flagCategoryIds, this.list, this.flagNum);
        } else if (this.urlFlag == "tagCourseFlag") {
          this.id = pathId.tagCourseId;
          await this.getTrees(this.id, this.list);
          await this.show(this.flagTagCourseIds, this.list, this.flagNum);
        } else if (this.urlFlag == "school") {
          this.id = pathId.collegeId;
          await this.getTrees(this.id, this.list);
          await this.show(this.flagSchoolIds, this.list, this.flagNum);
        } else if (this.urlFlag == "tagProjectFlag") {
          this.id = pathId.tagProjectId;
          await this.getTrees(this.id, this.list);
          await this.show(this.flagTagProjectIds, this.list, this.flagNum);
        } else if (this.urlFlag == "status") {
          this.id = pathId.status;
          await this.getTrees(this.id, this.list);
          await this.show(this.flagStatusIds, this.list, this.flagNum);
        }
      }, 500);
    },
    // 通过标签id逆向查找树节点
    getTrees(val, opt) {
      let that = this;
      for (let i = 0; i < opt.length; i++) {
        if (val == opt[i].id) {
          if (that.urlFlag == "category") {
            that.flagCategoryIds.unshift(opt[i].id);
          } else if (that.urlFlag == "tagCourseFlag") {
            that.flagTagCourseIds.unshift(opt[i].id);
          } else if (that.urlFlag == "school") {
            that.flagSchoolIds.unshift(opt[i].id);
          } else if (that.urlFlag == "tagProjectFlag") {
            that.flagTagProjectIds.unshift(opt[i].id);
          } else if (that.urlFlag == "status") {
            that.flagStatusIds.unshift(opt[i].id);
          }
          if (opt[i].parentId != 0) {
            that.getTrees(opt[i].parentId, this.allList);
          }
        } else {
          if (opt[i].childrenList != undefined) {
            that.getTrees(val, opt[i].childrenList);
          }
        }
      }
    },
    show(check, arr, numFlag) {
      let that = this;
      that.$nextTick(() => {
        if (arr && arr.length > 0) {
          for (let j = 0; j < arr.length; j++) {
            if (check[numFlag] == arr[j].id) {
              that.childrenList = arr[j].childrenList;
              that.clist = arr[j].childrenList;
              that.id = arr[j].id;
              that.num = parseInt(numFlag + 1);
              // if (check && check.length > that.num) {
              //   this.show(check, arr[j].childrenList, that.num);
              // }
            }
          }
        }
        setTimeout(() => {
          this.childrenList = this.clist;
        }, 50);
      });
    },
    getNewList(par) {
      let that = this;
      that.$emit("getNewList", par);
    },
    getHotList(categoryId) {
      let that = this;
      that.$emit("getHotList", categoryId);
    },
    clickCourse(val, index) {
      let that = this;
      that.childrenList = [];
      that.clist = val.childrenList;
      that.id = val.id || "";
      let par = {
        id: that.id,
        flag: that.urlFlag,
      };
      if (this.urlFlag == "category") {
        this.$router.push({
          query: merge(this.$route.query, { categoryId: that.id }),
        });
      } else if (this.urlFlag == "tagCourseFlag") {
        this.$router.push({
          query: merge(this.$route.query, { tagCourseId: that.id }),
        });
      } else if (this.urlFlag == "school") {
        this.$router.push({
          query: merge(this.$route.query, { collegeId: that.id }),
        });
      } else if (this.urlFlag == "tagProjectFlag") {
        this.$router.push({
          query: merge(this.$route.query, { tagProjectId: that.id }),
        });
      } else if (this.urlFlag == "status") {
        this.$router.push({
          query: merge(this.$route.query, { status: that.id }),
        });
      }
      if (that.tabs == 2) {
        that.$emit("getNewList", par);
      } else {
        that.$emit("getHotList", par);
      }
      setTimeout(() => {
        this.childrenList = this.clist;
      }, 100);
    },
  },
  watch: {},
};
</script>
<style lang="scss">
.item-title {
  //   display: inline-block;
  //   margin-left: 20px;
  //   position: relative;
  list-style: none;
  float: left;
  height: auto;
  a {
    font-size: 14px;
    display: inline-block;
    text-decoration: none;
    padding: 4px 15px;
    // margin-left: 20px;
  }
  .active {
    background: #3685fd33;
    color: #3685fd;
    border-radius: 15px;
  }
}
.item-children {
  .item-title {
    list-style: none;
    float: left;
    height: auto;
    a {
      font-size: 14px;
      display: inline-block;
      text-decoration: none;
      padding: 4px 15px;
      color: #777;
      &:hover {
        color: #3685fd;
      }
    }
    .active {
      background: #3685fd33;
      background: none !important;
      color: #3685fd;
      border-radius: 15px;
    }
  }
}
</style>
